import { render, staticRenderFns } from "./FetchV2.vue?vue&type=template&id=72c17c05&scoped=true&"
import script from "./FetchV2.vue?vue&type=script&lang=js&"
export * from "./FetchV2.vue?vue&type=script&lang=js&"
import style0 from "./FetchV2.vue?vue&type=style&index=0&id=72c17c05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c17c05",
  null
  
)

export default component.exports